export default {"src":"/_next/static/media/mb-lg.b5df45b5.svg","height":274,"width":836,"blurWidth":0,"blurHeight":0};